import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, eyebrow, lastUpdate, children }) => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white font-body">
      <Navbar />

      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/60 hover:text-[#007AFF] transition-colors mb-10"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
            — {eyebrow}
          </div>
          <h1
            data-testid="legal-page-title"
            className="font-heading text-4xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-6"
          >
            {title}
          </h1>

          <div className="flex items-center gap-1 mb-12">
            <div className="h-[3px] w-10 bg-[#0055A4]" />
            <div className="h-[3px] w-10 bg-white" />
            <div className="h-[3px] w-10 bg-[#EF4135]" />
          </div>

          {lastUpdate && (
            <div className="text-xs text-white/50 uppercase tracking-widest mb-10">
              Dernière mise à jour : {lastUpdate}
            </div>
          )}

          <div className="legal-content text-white/75 leading-relaxed space-y-6">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
